var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentCard',{attrs:{"title":"院内采购"}},[_c('NoticeList',{staticStyle:{"margin-bottom":"16px"}}),_c('PublicityList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }